import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `currentColor` : `var(--color-${color})`;
};
const SvgWhatsappColorIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path fill={getFillColor(props.color) === "currentColor" ? `var(--color-whatsapp)` : getFillColor(props.color)}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.669 2.336C12.165 0.83 10.165 0.001 8.034 0 3.642 0 0.068 3.574 0.067 7.966c-0.001 1.404 0.366 2.775 1.063 3.983L0 16.077l4.223 -1.108c1.164 0.635 2.474 0.969 3.807 0.97h0.003c4.391 0 7.965 -3.574 7.966 -7.966 0.001 -2.129 -0.827 -4.13 -2.331 -5.636zm-5.635 12.257h-0.003c-1.188 0 -2.353 -0.32 -3.37 -0.923l-0.242 -0.144 -2.506 0.657 0.669 -2.444 -0.157 -0.251c-0.663 -1.054 -1.013 -2.273 -1.012 -3.524 0.002 -3.651 2.972 -6.621 6.624 -6.621 1.769 0.001 3.431 0.69 4.681 1.942 1.25 1.251 1.938 2.915 1.937 4.684 -0.002 3.651 -2.972 6.621 -6.621 6.621zm3.632 -4.959c-0.199 -0.1 -1.178 -0.581 -1.36 -0.647 -0.183 -0.066 -0.315 -0.1 -0.448 0.1 -0.133 0.199 -0.514 0.648 -0.63 0.78 -0.116 0.133 -0.232 0.149 -0.431 0.05 -0.199 -0.1 -0.84 -0.31 -1.601 -0.988 -0.592 -0.528 -0.991 -1.18 -1.107 -1.379 -0.116 -0.199 -0.012 -0.307 0.087 -0.406 0.089 -0.089 0.199 -0.233 0.299 -0.349s0.133 -0.199 0.199 -0.332c0.066 -0.133 0.033 -0.249 -0.016 -0.349 -0.05 -0.1 -0.448 -1.08 -0.614 -1.478 -0.162 -0.388 -0.326 -0.335 -0.448 -0.342 -0.116 -0.006 -0.249 -0.007 -0.382 -0.007s-0.348 0.05 -0.531 0.249 -0.697 0.681 -0.697 1.66 0.713 1.926 0.813 2.059 1.404 2.143 3.4 3.006c0.475 0.205 0.846 0.328 1.135 0.419 0.477 0.152 0.911 0.13 1.254 0.079 0.382 -0.057 1.178 -0.482 1.343 -0.947s0.166 -0.864 0.116 -0.947 -0.183 -0.133 -0.382 -0.233z" />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgWhatsappColorStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgWhatsappColorIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const WhatsappColorIcon: any = SvgWhatsappColorStyle;
export default WhatsappColorIcon;
